import { Pipe, PipeTransform } from '@angular/core';
import { formatSecondsAsString } from '../format-call-details-seconds/format-detail-seconds.pipe';

@Pipe({
    name: 'activeDuration',
    pure: false,
    standalone: false
})
export class ActiveCallsDurationPipe implements PipeTransform {
   transform(startDate: string): string {
      const seconds = getSecondsFromStartDate(startDate);
      return formatSecondsAsString(seconds);
   }
}

export function getSecondsFromStartDate(startDate: string): number {
   const currentTime = new Date();
   const startDateObject = new Date(startDate);

   if (isNaN(startDateObject.getTime())) {
      return 0;
   }

   const seconds = Math.floor((currentTime.getTime() - startDateObject.getTime()) / 1000);

   return seconds;
}
